import React, { Suspense, useMemo } from 'react';

import { SnackbarProvider } from 'notistack';
import { Route, Routes } from 'react-router-dom';

import BaseLayout from '@layouts/BaseLayout';
import SuspenseFallback from '@components/common/SuspenseFallback';
import IRouteProps from '@interfaces/RouteProps';
import { SnackbarUtilsConfigurator } from '@utils/SnackBarUtils';
import DocusignCallback from '@layouts/search/DocusignCallback';
import routes from '.';

const DynamicLoader = ({ component }: { component: IRouteProps['component'] }) => {
  const LazyComponent = useMemo(() => component, [component]);

  return (
    <Suspense fallback={<SuspenseFallback fullscreen />}>
      <LazyComponent />
    </Suspense>
  );
};

const RenderRouteElement = ({ route }: { route: IRouteProps }) => {
  if (route.location === 'docusign') {
    return <DocusignCallback />;
  }
  if (route.skipAuth) {
    return <DynamicLoader component={route.component} />;
  }
  return <BaseLayout children={route.component} />;
};

const RenderRoute = () => {
  return (
    // <QueryParamProvider adapter={ReactRouter6Adapter}>
    <SnackbarProvider maxSnack={4} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
      <SnackbarUtilsConfigurator />
      <Routes>{routes.map(route => route.path.map(path => <Route key={path} path={path} element={<RenderRouteElement route={route} />} />))}</Routes>
    </SnackbarProvider>
    // </QueryParamProvider>
  );
};

export default RenderRoute;
